import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './ShopBase.css';
import star from '../assets/star.png';

function RedeemedRewards() {
  const { user } = useParams();
  const navigate = useNavigate();

  const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';
  const other = user === 'rija' ? 'sree' : 'rija';

  const [rewards, setRewards] = useState([]);
  const [points, setPoints] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [toggledRewards, setToggledRewards] = useState({});

  const [modal, setModal] = useState({
    open: false,
    message: '',
    onConfirm: null,
    item: null,
  });

  // =========================
  // Fetch rewards + points
  // =========================
  const fetchAll = async () => {
    try {
      const [rewardsRes, pointsRes] = await Promise.all([
        fetch(`${API_URL}/users/${other}/redeemed-rewards`),
        fetch(`${API_URL}/users/${other}/points`),
      ]);

      const rewardsData = await rewardsRes.json();
      const pointsData = await pointsRes.json();

      setRewards(rewardsData.redeemed_rewards || []);
      setPoints(pointsData.points || 0);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAll();
  }, [user, other]);

  // =========================
  // Toggle handler
  // =========================
  const handleToggle = (reward) => {
    const id = reward.redeemRewardId;

    if (!toggledRewards[id]) {
      setModal({
        open: true,
        message: 'Confirm Reward Usage?',
        item: reward,
        onConfirm: () => acknowledgeReward(reward),
      });
    } else {
      setToggledRewards((prev) => ({
        ...prev,
        [id]: false,
      }));
    }
  };

  // =========================
  // Acknowledge reward
  // =========================
  const acknowledgeReward = async (reward) => {
    try {
      const res = await fetch(
        `${API_URL}/rewards/${other}/acknowledge/${reward.redeemId}`,
        { method: 'POST' }
      );

      if (!res.ok) throw new Error();

      await fetchAll(); // refresh rewards + points
    } catch {
      alert('Something went wrong');
    } finally {
      setModal((m) => ({ ...m, open: false }));
    }
  };

  // =========================
  // Render guards
  // =========================
  if (loading) return <div className="modal">Loading...</div>;
  if (error) return <div className="modal error">Error: {error}</div>;

  return (
    <div className="shop-base" style={{ background: '#f0f0f0', paddingBottom: '80px' }}>
      {/* Title bar */}
      <div className="shop-title-bar">
        <h1 className="shop-title">
          {other.charAt(0).toUpperCase() + other.slice(1)}'s Redeemed Rewards
        </h1>

        <div className="points">
          <img src={star} alt="star" className="points-star" />
          <span className="points-value">{points}</span>
        </div>
      </div>

      {/* Content */}
      <div className="shop-content">
        <div
          className="panel rewards"
          style={{ background: '#fff5f5', borderColor: '#f06c6c' }}
        >
          <h2 className="panel-title" style={{ color: '#f06c6c' }}>
            Redeemed Rewards
          </h2>

          <ul>
            {rewards.length > 0 ? (
              rewards.map((r) => (
                <li key={r.redeemRewardId}>
                  <span className="item-text">{r.rewardDesc}</span>
                  <span className="item-cost reward-cost">-{r.rewardCost}</span>

                  <label className="toggle-switch">
                    <input
                      type="checkbox"
                      checked={!!toggledRewards[r.redeemRewardId]}
                      onChange={() => handleToggle(r)}
                    />
                    <span className="slider"></span>
                  </label>
                </li>
              ))
            ) : (
              <li className="empty">No redeemed rewards</li>
            )}
          </ul>
        </div>
      </div>

      {/* Confirm modal */}
      {modal.open && (
        <div className="confirm-modal-overlay">
          <div className="confirm-modal">
            <p className="confirm-message">{modal.message}</p>
            <div className="confirm-buttons">
              <button
                className="confirm-yes"
                onClick={() => {
                  modal.onConfirm();
                  setToggledRewards((prev) => ({
                    ...prev,
                    [modal.item.redeemRewardId]: true,
                  }));
                }}
              >
                Yes
              </button>
              <button
                className="confirm-no"
                onClick={() => {
                  setToggledRewards((prev) => ({
                    ...prev,
                    [modal.item.redeemRewardId]: false,
                  }));
                  setModal((m) => ({ ...m, open: false }));
                }}
              >
                No
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Back */}
      <button className="redeemed-btn" onClick={() => navigate(-1)}>
        Back
      </button>
    </div>
  );
}

export default RedeemedRewards;
